import { createAction } from 'redux-actions';

enum Type {
  GET_AUDIO = 'GET_AUDIO',
  SET_AUDIO_STORE = 'SET_AUDIO_STORE'
}

const getAudio = createAction(Type.GET_AUDIO);
const setAudioAIResponse = createAction<any>(Type.SET_AUDIO_STORE);

export default {
  Type,
  getAudio,
  setAudioAIResponse
};
